import { render, staticRenderFns } from "./RappiCategories.vue?vue&type=template&id=2dde02ba"
import script from "./RappiCategories.vue?vue&type=script&lang=js"
export * from "./RappiCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports